import { SnoozeReminderRequest } from "@shared/dtos/requests/reminderRequests.dto"

import { axiosPublic } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const snooze = async (reminderId: number | string, data: SnoozeReminderRequest): Promise<void> => {
  await axiosPublic({
    url: `public/reminders/${reminderId}/snooze`,
    method: "put",
    data,
  })
}
